// Angular
import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import { ApiServices } from '../model/config-file.model';
import { AppStateModel } from '../model/app.state.model';
import { AppInformationService } from './app-info.service';
import { AppState } from '../state/app.state';

@Injectable({
	providedIn: 'root'
})
export class SystemApiService {
	public api: ApiServices = {};
	public externalApp: any = {};

	/**
	 * Keeps updated the API Service with all possible URLS, ready to use
	 * @param store
	 */
	constructor(private store: Store, private appInfo: AppInformationService) {
		this.store
			.select(s => s.app)
			.subscribe((appStateModel: AppStateModel) => {
				if (this.appInfo.appName) {
					this.setConfig(appStateModel[this.appInfo.appName]);
				}
			});
	}

	/**
	 *  sometimes could the service return empty this just set again the data
	 */
	public reSetAPiInfo():void {
		const appSource = this.store.selectSnapshot(AppState.getAppState);
		this.setConfig(appSource[this.appInfo.appName]);
	}

	/**
	 * Set the current Api
	 */
	public setConfig(config: any): void {
		if (config && config.api) {
			this.api = config.api;
		}

		if (config && config.externalApp) {
			this.externalApp = config.externalApp;
		}
	}
}
